import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { useTheme, createUseStyles } from 'react-jss';
import { Container, Typography, Button } from '@sm/wds-react';
import { LogoWithText } from '@sm/webassets';
import { generateMetricsAttribute } from '@sm/metrics';

const COPY = defineMessages({
  THANK_YOU: {
    id: 'SurveyThanks.Embedded.ThankYou',
    defaultMessage: 'Thank you for taking the survey.',
    description:
      '[Type: Header][vis: high] - The primary message on the webpage. Used to say thank you to survey respondents and signal the end of the survey.',
  },
  POWERED_BY: {
    id: 'SurveyThanks.Embedded.PoweredBy',
    defaultMessage: 'powered by',
    description:
      '[Type: Label][Vis: med] - This figure of speech is used to introduce and display the SurveyMonkey Logo',
  },
  EMBEDDED_CTA: {
    id: 'SurveyThanks.Embedded.EmbeddedCTA',
    defaultMessage: 'Learn More',
    description:
      '[Type: Label][Vis: med] - This is the phrase used inside a button that directs views to a signup page',
  },
  EMBEDDED_CTA_TITLE: {
    id: 'SurveyThanks.Embedded.EmbeddedCTATitle',
    defaultMessage: 'Learn More About SurveyMonkey',
    description:
      '[Type: Label][Vis: low] - This text is here for accessibility reasons, it is usually hidden from users.',
  },
});

const useStyles = createUseStyles(theme => {
  return {
    embeddedContainer: {
      height: theme.util.fullHeight,
    },
    thankYouMessage: {
      paddingBottom: theme.spacing[4],
      fontWeight: 700,
    },
    logoWithText: {
      height: 23,
      padding: theme.spacing[4],
    },
  };
});

const Embedded = () => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const utSource = 'survey_thanks';
  const utSource2 = 'embedded';

  return (
    <Container
      className={classes.embeddedContainer}
      flex
      flexAlign="center"
      flexJustify="center"
      flexDirection="column"
    >
      <Container>
        <Typography component="div" variant="cardTitle" className={classes.thankYouMessage}>
          {t(COPY.THANK_YOU)}
        </Typography>
      </Container>
      <Container>
        <Typography component="span" variant="bodySm" color="dark-muted">
          {t(COPY.POWERED_BY)}
        </Typography>
      </Container>
      <Container>
        <LogoWithText className={classes.logoWithText} />
      </Container>
      <Container>
        <Button
          color="muted"
          size="sm"
          title={t(COPY.EMBEDDED_CTA_TITLE)}
          href={createURL('/user/sign-up/', {
            ut_source: utSource,
            ut_source2: utSource2,
          })}
          data-sm-metric={generateMetricsAttribute({
            data: {
              actionType: `${utSource}_click_${utSource2}_cta_to_sign_up`,
              actionFlow: { utSource },
            },
          })}
        >
          {t(COPY.EMBEDDED_CTA)}
        </Button>
      </Container>
    </Container>
  );
};

export default Embedded;
